<template>
  <orders-download-file-dialog
      v-if="true"
      :opened="true"
      :choices="choices"
      :unloading-from="unloadingFrom"
      :names="'viewer'"
      @close="closeDialog"
  >
  </orders-download-file-dialog>
</template>

<script>
import OrdersDownloadFileDialog from "@/modules/templates/OrdersDownloadFileDialog.vue";

export default {
  name: "DownloadFileDialog",
  props: {
    choices: Object,
    unloadingFrom: Function
  },
  components: {
      OrdersDownloadFileDialog
  },
  methods: {
    closeDialog(){
      this.$emit("close", false)
    }
  }
}
</script>

<style scoped>

</style>